import { useStatsigClient } from '@statsig/react-bindings'
import { useEffect, useState } from 'react'

export function useStatsigExperiment() {
  const { getExperiment } = useStatsigClient()
  const [configs, setConfigs] = useState()
  const [isExperimentTest, setIsExperimentTest] = useState(false)
  const experimentName = ''

  useEffect(() => {
    const config = getExperiment(experimentName)
    setConfigs(config)
    setIsExperimentTest(Boolean(config.get('feature_enabled')))
  }, [getExperiment])

  return { configs, isExperimentTest }
}
